// 收费项管理
const chargeItemsManagementJurisdiction = [
  { id: "014001001", label: "添加", children: [] },
  { id: "014001002", label: "修改", children: [] },
  { id: "014001003", label: "删除", children: [] }
];

// 收费管理
const chargeManagementJurisdiction = [
  { id: "014002001", label: "添加", children: [] }
];

// 退款管理
const refundManagementJurisdiction = [
  { id: "014003001", label: "添加", children: [] },
  { id: "014003002", label: "确认退款", children: [] },
  { id: "014003003", label: "导出", children: [] },
  { id: "014003004", label: "按住户添加", children: [] }
];

// 智慧收费
const paymentServiceJurisdictionChildren = [
  {
    id: "014001000",
    label: "收费项管理",
    routerName: "charge-items-management",
    children: chargeItemsManagementJurisdiction
  },
  {
    id: "014002000",
    label: "收费管理",
    routerName: "charge-management",
    children: chargeManagementJurisdiction
  },
  {
    id: "014003000",
    label: "退款管理",
    routerName: "refund-management",
    children: refundManagementJurisdiction
  },
  { id: "014004000", label: "操作日志", routerName: "charge-log", children: [] }
];

const paymentServiceJurisdiction = {
  id: "014",
  label: "智慧收费",
  children: paymentServiceJurisdictionChildren
};

export { paymentServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/paymentServiceJurisdiction.js